import Vue from 'vue'
import Vuex from 'vuex'

// 注册插件
Vue.use(Vuex)

// 静态创建store实例
export const store = new Vuex.Store()

export default function(options) {
    return Vue.$store = store
}